var $pdp = {
  accordion_trigger: '.dropdown-header'
};

var $cart = {
  trigger_open: '.cart-trigger',
  trigger_close: '.sidecart-overlay, .sidecart-close'
};

var $modal_geolocation = {
  selector_container: '.geo-country-selector-container',
  selector_display: '.geo-country-selector-display',
  selector_dropdown: '.geo-country-selector-dropdown',
  selector_dropdown_option: '.geo-country-selector-dropdown-option'
};

var $global = {
  select_dd_display: '.select-dd-display',
  select_dd_options: '.select-dd-options',
  select_dd_option: '.select-dd-options a',
  select_dd_details: '.our-guarantee-country-details',
  select_dd_details_contact_email: '.our-guarantee-country-details-email span',
  select_dd_details_contact_message: '.our-guarantee-country-details-message'
}

$(document).ready(() => {
  listeners();
  update_geolocation_modal();
});

function listeners() {
  // Cart Listeners
  $(document).on('click', $cart.trigger_open, function(){
    $('body').addClass('sidecart-open');
  });
  $(document).on('click', $cart.trigger_close, function(){
    $('body').removeClass('sidecart-open');
  });
  // Accordions
  $(document).on('click', $pdp.accordion_trigger, function(){
    $(this).toggleClass('active');
  });
  // Select Dropdowns
  $(document).on('click', $global.select_dd_display, function(){
    var selectName = $(this).attr('name');
    $('.select-dd-container[name="' + selectName + '"]').toggleClass('active');
  });
  $(document).on('click', $global.select_dd_option, function(){
    var selectName = $(this).attr('name');
    var selectNameValue = $(this).text();
    $('.select-dd-container[name="' + selectName + '"]').removeClass('active');
    $('.select-dd-display[name="' + selectName + '"]').text(selectNameValue);
    $('.our-guarantee-country-selector').removeClass('active');
    if($(this).attr('type') == "email") {
      var selectContactInfo = $(this).attr('content');
      $($global.select_dd_details_contact_email).text(selectContactInfo);
      $($global.select_dd_details).addClass('active-email');
    }
    else if($(this).attr('type') == "message") {
      var selectContactInfo = $(this).attr('content');
      $($global.select_dd_details_contact_message).text(selectContactInfo);
      $($global.select_dd_details).addClass('active-message');
    }
    else {
      $($global.select_dd_details).removeClass('active-email').removeClass('active-message');
    }
  });

  if (document.body.classList.contains("page-our-guarantee")) {
    document.addEventListener('click', function(event) {
      const container = document.getElementById('our-guarantee-country-selector-container');
      if (!container.contains(event.target)) {
        if (container) {
          container.classList.remove("active");
        }
      }
    });
  }

}



function update_geolocation_modal() {
  const country_selector_display = '<div class="geo-country-selector-container">' +
    '<div class="geo-country-selector-display form-field-style">United States' +
    '<svg class="icon-dd-arrow" xmlns="http://www.w3.org/2000/svg" width="19.769" height="11.218" viewBox="0 0 19.769 11.218">' +
      '<path id="Path_2" data-name="Path 2" d="M0,0,8.533-8,16,0" transform="translate(1.885 9.333)" fill="none" stroke="#2a2d7d" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.667"></path>' +
    '</svg></div>';
  const country_selector_dropdown =
    '<div class="geo-country-selector-dropdown">' +
      '<span ref="https://babiators.com" label="United States" class="geo-country-selector-dropdown-option">United States</span>' +
      '<span ref="https://babiators.ca" label="Canada" class="geo-country-selector-dropdown-option">Canada</span>' +
      '<span ref="https://babiators.net.au" label="Australia" class="geo-country-selector-dropdown-option">Australia</span>' +
      '<span ref="https://babiators-uk.com" label="United Kingdom" class="geo-country-selector-dropdown-option">United Kingdom</span>' +
    '</div>' +
    '</div>';
  const country_selector_cta = '<a href="https://babiators.com" class="geo-country-selector-cta">Shop Now</a>';
  const country_selector = country_selector_display + country_selector_dropdown + country_selector_cta;
  $(country_selector).insertAfter('.md-modal__body');

  $(document).on('click', $modal_geolocation.selector_display, function(){
    $($modal_geolocation.selector_container).toggleClass('open');
  });

  $(document).on('click', $modal_geolocation.selector_dropdown_option, function(){
    var country_selected = $(this).attr('ref');
    var country_name = $(this).attr('label');

    $($modal_geolocation.selector_container).removeClass('open');
    $($modal_geolocation.selector_display).text(country_name);
    $('.geo-country-selector-cta').attr( 'href', country_selected);
  });
}

$(document).on('cart.ready', (_event, _cart) => {
  update_sidecart_upsells();
});

$(document).on('cart.requestComplete', (_event, _cart) => {
  update_sidecart_upsells();
});

function update_sidecart_upsells() {
  var product_type = '';
  if (CartJS.cart.item_count > 0) {
    var product_type = CartJS.cart.items[0].product_type;
  }
  else {
    $('.sidecart-container').removeClass('has-rec');
  }

  $('.sidecart-recommendation').removeClass('show');
  if($('.sidecart-recommendation[data-type="' + product_type + '"]').length > 0) {
    console.log('Recommendation Found!');
    $('.sidecart-container').addClass('has-rec');
  }
  else {
    $('.sidecart-container').removeClass('has-rec');
  }
  $('.sidecart-recommendation[data-type="' + product_type + '"]').addClass('show');
}
